import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { PitchTitleIcon } from './svg';
import styles from 'styles/pages/Benefits/Benefits.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  return (
    <section className={cn('pitch')}>
      <div className={cn('container')}>
        <div className={cn('pitch__title-box')}>
          <h2 className={cn('pitch__title')}>
            {PitchTitleIcon}
            Unlock a World of Opportunities: The Core Benefits of DFA
          </h2>
          <p className={cn('pitch__title-description')}>
            Explore how DFA equips freight forwarders with the tools, connections,
            and resources to thrive in today’s competitive global logistics industry.
          </p>
        </div>
        <div className={cn('pitch__paragraphs')}>
          <p className={cn('pitch__paragraph')}>
            At DFA, we’re not just an alliance—we’re the catalyst for transformative growth and
            sustained success in the freight forwarding industry. Through dynamic real-time shipping
            leads that open doors to high-value opportunities and a robust global network that drives
            meaningful connections, DFA delivers the tools to outpace the competition.
          </p>
          <p className={cn('pitch__paragraph')}>
            Our cutting-edge resources and exclusive member perks tackle the complexities of
            logistics head-on, fueling efficiency, maximising reach, and propelling your business
            to new heights. Becoming a DF Alliance member means joining an elite ecosystem that
            redefines possibilities, amplifies business outcomes, and ensures your success in an
            ever-changing, fast-paced market.
          </p>
        </div>
        <div className={cn('pitch__buttons')}>
          <Link className={cn('pitch__button-join')} href="/membership">
            Join DFA Alliance Now
          </Link>
        </div>
      </div>
    </section>
  );
}

export default SectionPitch;